import { render, staticRenderFns } from "./TransactionDetailForm.vue?vue&type=template&id=540a0534"
import script from "./TransactionDetailForm.vue?vue&type=script&lang=js"
export * from "./TransactionDetailForm.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailForm.vue?vue&type=style&index=0&id=540a0534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports